import { render, staticRenderFns } from "./displayImg.vue?vue&type=template&id=3a282c1d"
import script from "./displayImg.vue?vue&type=script&lang=js"
export * from "./displayImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports